// extracted by mini-css-extract-plugin
module.exports = {" _key":"@dojo/widgets/trigger-popup","root":"trigger-popup-m__root__2S7Kv","trigger":"trigger-popup-m__trigger__2isxr"};